import type { SVGProps } from 'react';
import * as React from 'react';

export const UpsellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="104"
    height="104"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.668586 31.8788C1.47044 20.173 1.87137 14.32 8.15322 8.05358 14.4351 1.78716 20.2443 1.40357 31.8628.636397 37.6714.252851 44.3876 0 52 0c7.6125 0 14.3286.252851 20.1372.636396C83.7557 1.40357 89.565 1.78716 95.8468 8.05359 102.129 14.32 102.53 20.173 103.331 31.8789 103.733 37.7405 104 44.4697 104 52c0 7.0957-.237 13.48-.6 19.0975-.795 12.2896-1.193 18.4344-7.4717 24.7291-6.2791 6.2944-12.4668 6.7104-24.842 7.5414-5.673.381-12.0717.632-19.0863.632-7.0146 0-13.4132-.251-19.0863-.632-12.3752-.831-18.5628-1.247-24.84194-7.5414C1.79265 89.5319 1.39524 83.3871.600423 71.0975.23712 65.48 0 59.0957 0 52c0-7.5303.267061-14.2595.668586-20.1212Z"
        fill="#DAFFF4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3004 29.8421c4.2759-3.2531 11.3346-7.045 21.1821-7.045 9.7628 0 16.3959 3.7276 20.3383 6.9493-.2054.1151-.4303.2479-.6837.3977l-2.0387 1.2044c-1.9997 1.1813-2.9995 1.772-3.2538 2.7603-.2542.9882.3365 1.9881 1.5179 3.9878l3.2601 5.5182c1.1814 1.9997 1.7721 2.9996 2.7603 3.2538.9883.2542 1.9881-.3365 3.9878-1.5179l1.9102-1.1285c1.1848-.6999 1.7771-1.0498 2.0932-1.8005.3161-.7506.1813-1.3015-.0884-2.4033-.3426-1.4-.9677-3.2242-2.1078-5.2212-1.0928-1.9142-2.317-3.297-3.354-4.2497-3.5236-3.6372-11.3534-9.8712-24.3414-9.8712-12.0579 0-20.1856 5.3738-24.374 9.0343-.2216.1643-.4566.3715-.7446.6254-1.0835.9553-2.4124 2.4003-3.589 4.4612-1.1401 1.997-1.7652 3.8212-2.1078 5.2212-.2697 1.1018-.4045 1.6527-.0884 2.4033.3161.7507.9085 1.1006 2.0932 1.8005l1.9102 1.1285c1.9997 1.1814 2.9996 1.7721 3.9878 1.5179s1.5789-1.2541 2.7603-3.2538l3.2601-5.5182c1.1814-1.9997 1.7721-2.9996 1.5179-3.9878-.2542-.9883-1.2541-1.579-3.2538-2.7603l-2.0387-1.2044c-.1859-.1099-.3565-.2107-.5153-.302Z"
        fill="url(#b)"
      />
      <path
        d="M26.176 48.7433c-1.9526 5.2519-4.7875 11.934-9.3051 13.6867-4.5176 1.7527-11.56365-3.6956-3.2187-13.6867 1.8997-2.2745 6.0262-7.144 8.4966-13.8526M77.7742 48.7433c1.9526 5.2519 4.7875 11.934 9.3051 13.6867 4.5176 1.7527 11.5636-3.6956 3.2187-13.6867-1.8997-2.2745-6.0262-7.144-8.4966-13.8526"
        stroke="#FFC348"
        strokeWidth="2.71164"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="51.9748" cy="57.425" r="28.5666" fill="url(#c)" />
      <path
        d="M41.0195 40.2666c.8336.8335 3.5658 4.0487 10.9552 4.0487s10.1217-3.2152 10.9552-4.0487"
        stroke="#1E1A38"
        strokeWidth="2.1208"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="2.72096"
        cy="2.72096"
        r="2.72096"
        transform="matrix(-1 0 0 1 48.2344 32.3203)"
        fill="#1E1A38"
      />
      <circle
        cx="2.72096"
        cy="2.72096"
        r="2.72096"
        transform="matrix(-1 0 0 1 61.2783 32.3203)"
        fill="#1E1A38"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="51.8563"
        y1="27.6928"
        x2="51.8563"
        y2="56.7954"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#773FFC" />
        <stop offset=".784615" stopColor="#3C19A2" />
      </linearGradient>
      <linearGradient
        id="c"
        x1="51.9748"
        y1="28.8584"
        x2="76.9706"
        y2="84.2912"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFCE51" />
        <stop offset="1" stopColor="#FFAE35" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h104v104H0z" />
      </clipPath>
    </defs>
  </svg>
);
